import { api } from '../api';
import { AxiosResponse } from "axios";
import { ValidateTokenData } from '../interfaces/Auth';
import { EmptyObjectData, StandardResponse } from '../interfaces/Common';
import { UserData, UserSignUpFormRequest, UserSignUpFormResponseData } from '../interfaces/User';

export async function login(credentials: { email: string; password: string }): Promise<StandardResponse<UserData>> {
    const response: AxiosResponse<StandardResponse<UserData>> = await api.post("/preboard/signin", credentials, {
        headers: { skipAuth: true }
    });
    return response.data;
}

export async function register(user: UserSignUpFormRequest): Promise<StandardResponse<UserSignUpFormResponseData>> {
    const response: AxiosResponse<StandardResponse<UserSignUpFormResponseData>> = await api.post("/preboard/signup", user, {
        headers: { skipAuth: true }
    });
    return response.data;
}

export async function validate(): Promise<StandardResponse<ValidateTokenData>> {
    const response: AxiosResponse<StandardResponse<ValidateTokenData>> = await api.get("/preboard/validate");
    return response.data;
}

export async function forgotPassword(user: { email: string; }): Promise<StandardResponse<EmptyObjectData>> {
    const response: AxiosResponse<StandardResponse<EmptyObjectData>> = await api.post("/preboard/password/reset", user, {
        headers: { skipAuth: true, skipGlobalAuthError: true }
    });
    return response.data;
}

export async function resetPassword(newPassword: string, token: string | null): Promise<StandardResponse<EmptyObjectData>> {
    const response: AxiosResponse<StandardResponse<EmptyObjectData>> = await api.post(
        "/preboard/password/update",
        { newPassword },
        {
            headers: {
                token,
                skipAuth: true,
                skipGlobalAuthError: true
            },
        }
    );
    return response.data;
}
